module.exports = __webpack_public_path__ + "static/media/orderHardCardsSpa.803e961d.jpg";